import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { FormData } from "@/utils/calculationUtils";
import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface CalculatorFormProps {
  formData: FormData;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCalculate: () => void;
}

export const CalculatorForm = ({ formData, onInputChange, onCalculate }: CalculatorFormProps) => {
  return (
    <div className="space-y-4">
      <div className="floating-input">
        <Label htmlFor="name" className="text-white">Full Name</Label>
        <Input
          id="name"
          name="name"
          value={formData.name}
          onChange={onInputChange}
          className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-gray-400"
          placeholder="John Doe"
        />
      </div>

      <div className="floating-input">
        <Label htmlFor="email" className="text-white">Email Address</Label>
        <Input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={onInputChange}
          className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-gray-400"
          placeholder="john@example.com"
        />
      </div>

      <div className="floating-input">
        <Label htmlFor="salary" className="text-white">Monthly Salary (R)</Label>
        <Input
          id="salary"
          name="salary"
          type="number"
          value={formData.salary}
          onChange={onInputChange}
          className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-gray-400"
          placeholder="0.00"
        />
      </div>

      <div className="floating-input">
        <div className="flex items-center gap-2">
          <Label htmlFor="obligations" className="text-white">Monthly Credit Repayments (R)</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="max-w-xs">Include all monthly loan payments and credit obligations (e.g., personal loans, credit cards, store accounts)</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="mt-1">
          <Input
            id="obligations"
            name="obligations"
            type="number"
            value={formData.obligations}
            onChange={onInputChange}
            className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-gray-400"
            placeholder="0.00"
          />
          <p className="text-xs text-gray-400 mt-1">
            Only include credit payments you're legally obligated to pay monthly
          </p>
        </div>
      </div>

      <Button
        onClick={onCalculate}
        className="w-full transition-all duration-300 hover:translate-y-[-2px] bg-primary text-white hover:bg-primary/90"
      >
        Calculate Savings
      </Button>
    </div>
  );
};